import config from "../../config/config";


// Recursively build a nested permission tree
export const buildPermissionTree = (permissionsArray = [], parentId = null) => {
  return permissionsArray
    .filter((item) => item.parentId === parentId)
    .map((item) => ({
      ...item,
      children: buildPermissionTree(permissionsArray, item.id),
    }));
};

// Recursively find a node or its action by dot path
// Example: "orders.order_list.filter"
 
export const findPermission = (nodes = [], pathParts = []) => {
  if (!nodes.length || !pathParts.length) return null;
  const [current, ...rest] = pathParts;
  const node = nodes.find((n) => n.category === current);
  if (!node) return null;
  // If this is the last part and refers to action → check actions under node
  if (rest.length === 1) {
    const maybeAction = rest[0];
    const actionNode = node.children?.find((c) => c.action === maybeAction);
    if (actionNode) return actionNode;
  }
  // If more parts left → go deeper
  if (rest.length > 0) {
    return findPermission(node.children || [], rest);
  }
  // Otherwise, reached category itself
  return node;
};



// Check permission using dot path (e.g. "orders.order_list.filter")
export const hasPermission = (permissionsData, path) => {
  if(!config.enablePermissionCheck){
    return true
  }
  if (!permissionsData || !permissionsData.permissions) return false;
  const { permissions } = permissionsData;
  const tree = buildPermissionTree(permissions);
  const pathParts = path.split(".");
  const node = findPermission(tree, pathParts);
  return !!(node && node.assigned);
};


